export function isDate(value) {
    return toString.call(value) === '[object Date]';
}
export function isNumber(value) {
    return typeof value === 'number';
}
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/@swimlane/ngx-charts/release/utils/types.js
// module id = ../../../../@swimlane/ngx-charts/release/utils/types.js
// module chunks = 4